// extracted by mini-css-extract-plugin
module.exports = {"formSection":"styles_formSection__uXop4","label":"styles_label__1wYmL","content":"styles_content__EqPO5"};